import React from "react"
import { useState, useEffect } from "react"
import General from "services/GeneralEndpoints"

// Import Docs
import DeliveryPartnerAttachments from "pages/DeliveryPartner/Attachments"
import NoObjectionAttachments from "pages/NoObjectionLetter/Attachments"
import AccreditationAttachments from "pages/NominationLetterAccreditation/Attachments"
import EnvironmentalAuditAttachments from "pages/EnvironmentalAudit/Attachments"

const user = JSON.parse(localStorage.getItem("authUser"))

let generalService = new General(user)

const RequiredDocs = props => {
  const [RequiredDocuments, setRequiredDocuments] = useState([])
  useEffect(() => {
    
    if (props.service_id == 6) {
      // Delivery Partner
      buildDocsView(DeliveryPartnerAttachments)
    } else if (props.service_id == 17001) {
      // Nomination Accreditation
      buildDocsView(AccreditationAttachments)
    } else if (props.service_id == 17002) {
      // No Objection service
      buildDocsView(NoObjectionAttachments)
    } else if (props.service_id == 17003) {
      // Environmental Audit
      const auditSteps = [
        { id: 1, description: "Application for Environmental Audit Certificate" },
        { id: 2, description: "Terms of reference of the Environmental Audit" },
        { id: 3, description: "Choice of experts to conduct Environmental Audit" },
        { id: 4, description: "Environmental Audit Report" },
        { id: 5, description: "Submission of the Environmental Audit Report" },
        { id: 6, description: "Review of Environmental Audit Report and decision making" },
      ];
      
      buildDocsView(auditSteps)
    } else {
      fetchServiceAttachments(props.service_id)
    }
  }, [])

  const buildDocsView = docs => {
    const attachments = docs.map((item, index) => {
      return (
        <li>
          <span
            key={index}
            value={item.id}
            className="text-dark badge badge-primary"
          >
            {item.description}
          </span>
        </li>
      )
    })
    setRequiredDocuments(attachments)
  }

  const fetchServiceAttachments = service_id => {
    generalService.getServiceAttachments(service_id).then(response => {
      // console.log(response)
      if (response.status) {
        buildDocsView(response.data)
      }
    })
  }

  return (
    <div>
      <div>
        <span className="text-dark d-block my-4 font-weight-bold">
          First time application:
        </span>
        <ul className="doc-list doc-list d-block">
          <li>{RequiredDocuments}</li>
        </ul>
      </div>
    </div>
  )
}

export default RequiredDocs
